import React from 'react';
import cx from 'classnames';
import trackNavigationClickEvent, { NAV_SECTIONS } from 'util/trackNavigationClickEvent';
import GuestNavLeft from './GuestNavLeft';
import GuestNavRight from './GuestNavRight';

import styles from './PublicRegistryNavContainer.module.less';

const PublicRegistryNavContainer = () => {
  function handleClick(e) {
    trackNavigationClickEvent({ node: e.target, section: NAV_SECTIONS.primary });
  }
  return (
    <div className={styles.container}>
      <div
        className={cx('top-nav__container-v2', styles.publicRegistry)}
        onClick={(e) => handleClick(e)}
      >
        <GuestNavLeft />
        <GuestNavRight />
      </div>
    </div>
  );
};

export default PublicRegistryNavContainer;
